export enum TranslationSource {
  Ai = "ai",
  Merchant = "merchant",
}
